<template>
  <header class="header">
    <nav class="nav">
      <div class="logo" @click.prevent="navigateToAnchor('banner')"></div>
      <div class="nav-links">
        <a href="#" @click.prevent="navigateToAnchor('aboutUs')" :class="{ 'nav-link-active': activeAnchor === 'aboutUs' }">关于我们</a>
        <a href="#" @click.prevent="navigateToAnchor('product')" :class="{ 'nav-link-active': activeAnchor === 'product' }">原创</a>
        <a href="#" @click.prevent="navigateToAnchor('ip')" :class="{ 'nav-link-active': activeAnchor === 'ip' }">合作</a>
        <a href="#" @click.prevent="navigateToAnchor('cooperation')" :class="{ 'nav-link-active': activeAnchor === 'cooperation' }">渠道</a>
        <a href="#" @click.prevent="navigateToAnchor('case')" :class="{ 'nav-link-active': activeAnchor === 'case' }">营销案例</a>
        <a href="#" @click.prevent="navigateToAnchor('delivery')" :class="{ 'nav-link-active': activeAnchor === 'delivery' }">供应链</a>
        <a href="#" @click.prevent="toggleDropdown" class="shop-link" :class="{ 'shop-link-active': showDropdown }">
          线上商城
          <span class="arrow-icon" :class="{ 'arrow-up': showDropdown, 'arrow-icon-active': showDropdown }">
            <svg t="1769664444569" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="9704" width="200" height="200">
              <path
                d="M513.728968 801.548285L13.63942599 301.254151c-18.242732-18.242732-18.106338-47.73799 0.30688701-65.844327a47.226511 47.226511 0 0 1 66.389904 0.272788l433.154061 433.358652L943.643665 235.784908A47.192413 47.192413 0 0 1 1010.033569 235.307528 46.30585 46.30585 0 0 1 1010.545048 301.151856l-496.81608 500.396429z"
                fill="#ffffff" p-id="9705"></path>
            </svg>
          </span>
        </a>
        <div class="contact-link-wrapper" @mouseenter="showContactQr = true" @mouseleave="showContactQr = false">
          <a href="#">联系我们</a>
          <div class="qr-popup qr-popup-contact" v-if="showContactQr">
            <div class="content-qr-image">
              <img src="https://cdn.magicmart.vip/website/assets/wxQr.png" alt="微信二维码" mode="aspectFill">
            </div>
          </div>
        </div>
      </div>
    </nav>
    <div class="dropdown-menu" v-if="showDropdown">
      <div class="dropdown-item" @click="openTmall">天猫旗舰店</div>
      <div class="dropdown-item" @mouseenter="showAppQr = true" @mouseleave="showAppQr = false">魔力玛特APP</div>
      <div class="dropdown-item" @mouseenter="showMiniQr = true" @mouseleave="showMiniQr = false">魔力玛特小程序</div>
      <div class="dropdown-item" @click="openXiaohongshu">魔力玛特小红书</div>

      <div class="qr-popup qr-popup-right" v-show="showAppQr" @mouseenter="showAppQr = true"
        @mouseleave="showAppQr = false">
        <div class="qr-content">
          <img src="https://cdn.magicmart.vip/website/assets/app-qr.png" alt="APP下载二维码" class="qr-image">
          <p>扫一扫下载APP</p>
        </div>
      </div>

      <div class="qr-popup qr-popup-left" v-show="showMiniQr" @mouseenter="showMiniQr = true"
        @mouseleave="showMiniQr = false">
        <div class="qr-content">
          <img src="https://cdn.magicmart.vip/website/assets/mini-qr.png" alt="小程序二维码" class="qr-image">
          <p>扫一扫打开小程序</p>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
export default {
  name: 'PageHeader',
  data() {
    return {
      showDropdown: false,
      showAppQr: false,
      showMiniQr: false,
      showContactQr: false,
      activeAnchor: ''
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
    window.addEventListener('scroll', this.handleScroll)
    this.$nextTick(() => {
      this.checkActiveAnchor()
    })
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    toggleDropdown() {
      this.showDropdown = !this.showDropdown
      this.showAppQr = false
      this.showMiniQr = false
    },
    handleOutsideClick(event) {
      if (!event.target.closest('.header')) {
        this.showDropdown = false
      }
    },
    openTmall() {
      window.open('https://m.tb.cn/h.7JlmOL5yvtWUIpo', '_blank')
      this.showDropdown = false
    },
    openXiaohongshu() {
      window.open('https://xhslink.com/m/7fHGgpiVyPw', '_blank')
      this.showDropdown = false
    },
    navigateToAnchor(anchorId) {
      this.showDropdown = false
      if (this.$route.path !== '/') {
        this.$router.push('/').then(() => {
          this.$nextTick(() => {
            this.scrollToAnchor(anchorId)
          })
        })
      } else {
        this.scrollToAnchor(anchorId)
      }
    },
    scrollToAnchor(anchorId) {
      this.activeAnchor = anchorId
      const element = document.getElementById(anchorId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },
    handleScroll() {
      this.checkActiveAnchor()
    },
    checkActiveAnchor() {
      const anchors = ['aboutUs', 'product', 'ip', 'cooperation', 'case', 'delivery']
      let activeAnchor = ''
      
      for (let anchor of anchors) {
        const element = document.getElementById(anchor)
        if (element) {
          const rect = element.getBoundingClientRect()
          const windowHeight = window.innerHeight
          
          if (rect.top <= windowHeight / 2 && rect.bottom >= windowHeight / 2) {
            activeAnchor = anchor
            break
          }
        }
      }
      
      this.activeAnchor = activeAnchor
    }
  }
}
</script>

<style scoped>
.header {
  background: rgba(0, 0, 0, 0.8);
  width: 100%;
  height: 82px;
  position: fixed;
  top: 0;
  z-index: 9999;
}

.nav {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%
}

.logo {
  font-weight: bold;
  background-image: url("https://cdn.magicmart.vip/website/assets/topLogo.png");
  width: 193px;
  height: 40px;
  background-repeat: no-repeat;
  background-size: 100%;
  cursor: pointer;
}

.nav-links {
  display: flex;
  list-style: none;
  align-items: center;
}

.nav-links a {
  color: white;
  text-decoration: none;
  transition: opacity 0.3s;
  font-size: 20px;
  margin-left: 60px;
  font-weight: 600;
}

.nav-links a:hover {
  color: #A34EFF
}

.nav-link-active {
  color: #A34EFF !important;
}

.shop-link {
  position: relative;
  display: flex;
  align-items: center;
  gap: 6px;
}

.shop-link-active {
  color: #A34EFF !important;
}

.arrow-icon {
  display: inline-flex;
  align-items: center;
  transition: transform 0.3s ease;
}

.arrow-icon svg {
  width: 16px;
  height: 16px;
}

.arrow-up {
  transform: rotate(180deg);
}

.arrow-icon-active svg path {
  fill: #A34EFF;
  stroke: #A34EFF;
}

.dropdown-menu {
  position: absolute;
  top: 82px;
  right: 29%;
  transform: translateX(50%);
  width: 183px;
  height: 282px;
  background: rgba(0, 0, 0, 0.8);
  z-index: 10000;
}

.dropdown-item {
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 20px;
  color: #FCFAFF;
  cursor: pointer;
  transition: all 0.3s;
}

.dropdown-item:hover {
  color: #A34EFF;
}

.qr-popup {
  position: absolute;
  top: 95px;
  right: 100%;
  margin-right: 20px;
  z-index: 10001;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.qr-popup-right {
  right: 100%;
  margin-right: 20px;
}

.qr-popup-left {
  right: 100%;
  margin-right: 20px;
}

.qr-popup-contact {
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 30px;
  right: auto;
}

.contact-link-wrapper {
  position: relative;
  display: flex;
}

.qr-content {
  background: #FFFFFF;
  border-radius: 12px;
  padding: 6px;
  text-align: center;
  position: relative;
}

.qr-image {
  width: 131px;
  height: 131px;
  object-fit: contain;
}

.qr-content p {
  margin-top: 7px;
  color: #333;
  font-weight: 600;
  font-size: 16px;
  color: #030303;
}

.content-qr-image {
  width: 143px;
  height: 170px;
  background: #fff;
}

.content-qr-image img {
  width: 100%;
  height: 100%;
}
</style>
